/**
 * PoiList — 위치·교통 등 POI 목록 (목업 `.poi`).
 *
 * 순수 프레젠테이션. 아이콘 박스(sunk) + 제목/부제 + 우측 거리(tabular-nums).
 * 각 행은 상단 하이라인으로 구분하며 첫 행은 하이라인을 생략한다.
 */

import React from 'react';

export interface PoiItem {
  icon?: React.ReactNode;
  title: string;
  sub?: string;
  distance?: string;
}

export interface PoiListProps {
  items: PoiItem[];
  className?: string;
}

export function PoiList({ items, className = '' }: PoiListProps) {
  return (
    <div className={className}>
      {items.map((item, i) => (
        <div
          key={i}
          className="flex items-center gap-[10px] border-t border-ca-line-soft py-[9px] first:border-t-0"
        >
          <span className="flex h-[26px] w-[26px] flex-shrink-0 items-center justify-center rounded-ca-md bg-block text-accent-dark">
            {item.icon}
          </span>
          <div className="min-w-0">
            <div className="text-[13px] font-bold text-ink">{item.title}</div>
            {item.sub && <div className="text-[11.5px] text-muted">{item.sub}</div>}
          </div>
          {item.distance && (
            <div className="ml-auto whitespace-nowrap text-[12px] font-bold tabular-nums text-body">
              {item.distance}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default PoiList;
